import { ref } from 'vue'

export const langs: ReadonlyArray<string> = ['th', 'en']

export const lang = ref('th')
